import { Form, type FormProps, Typography } from 'antd';

import styled from '@emotion/styled';

export const Container = styled.div`
  width: 100%;
`;

export const Divider = styled.div`
  width: 1px;
  height: 40px;
  background-color: ${({ theme }) => theme.colors.strokeDarkGrey};
  margin: 0 8px;
`;

export const FormControl = styled(Form.Item)<FormProps>`
  && {
    margin-bottom: 0;

    /* Sit the clear "×" to the left of the custom expand arrow (~20px wide at
       the right edge) so the two no longer overlap. */
    .ui-select-clear {
      margin-top: -8px;
      inset-inline-end: 34px;
    }
  }
`;

export const DrawerContainer = styled.div`
  height: calc(100vh - 112px);
`;

export const DrawerTitle = styled(Typography.Title)`
  &.ui-typography {
    font-size: 28px;
    margin-bottom: 0;
  }
`;

export const SwitchLabel = styled.div`
  font-weight: 600;
`;

export const ControlLabel = styled.span`
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.blackSecondary};
`;
